// noinspection ES6UnusedImports
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Layer from '@bonprix/pattern-library/components/layer';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Button from '@bonprix/pattern-library/templates/button/default';
import CoreMessages from '@core/scripts/components/message-list';
import Landmark from '@core/scripts/components/landmark-adapter';

export default function WishlistErrorLayer({texts}) {
    const [opened, setOpened] = useState(false);
    const errorType = useRef(undefined);

    const errorMessages = useMemo(
        () => ({
            FULL: {
                headline: texts.bff_wishlist_error_full_headline,
                content: texts.bff_wishlist_error_full_content,
                landmark: 'wishlist_error_layer--full',
            },
            ERROR: {
                headline: texts.bff_wishlist_error_default_headline,
                content: texts.bff_wishlist_error_default_content,
                landmark: 'wishlist_error_layer--default',
            },
            DUPLICATE: {
                headline: texts.bff_wishlist_error_default_headline,
                content: texts.bff_wishlist_error_default_content,
                landmark: 'wishlist_error_layer--duplicate',
            },
            REMOVE: {
                headline: texts.bff_wishlist_error_remove_headline,
                content: texts.bff_wishlist_error_remove_content,
                landmark: 'wishlist_error_layer--remove',
            },
            FALLBACK: {
                headline: texts.bff_wishlist_error_default_headline,
                content: '',
                landmark: 'wishlist_error_layer--default',
            },
        }),
        [texts],
    );

    useEffect(() => {
        const messages = [
            MessageBroker.subscribe(CoreMessages.WISHLIST.SHOW_ERROR_LAYER, ({error}) => {
                if (error) {
                    openErrorLayer(error);
                }
            }),
        ];

        return () => {
            messages.forEach((message) => MessageBroker.unsubscribe(message));
        };
    }, []);

    const openErrorLayer = (error) => {
        if (error) {
            errorType.current = error;
            setOpened(true);

            const lmValue = errorMessages[error]?.landmark || errorMessages.FALLBACK.landmark;
            Landmark.sendLandmark({
                landmark: 'layer_view',
                name: lmValue,
            });
        }
    };

    useEffect(() => {
        if (opened) {
            let toWishlistLinkElement;
            setTimeout(() => {
                // setTimeout to ensure the DOM is fully updated before querying the element
                toWishlistLinkElement = document.querySelector('.layer__text-content a');
                if (toWishlistLinkElement) {
                    toWishlistLinkElement.addEventListener('click', onClickToWishlistLink);
                }
            }, 0);

            return () => {
                if (toWishlistLinkElement) {
                    toWishlistLinkElement.removeEventListener('click', onClickToWishlistLink);
                }
            };
        }
    }, [opened]);

    const close = () => {
        setOpened(false);
        const lmValue = errorMessages[errorType.current]?.landmark || errorMessages.FALLBACK.landmark;
        Landmark.sendClickLandmark(lmValue + '_close');
    };

    const onClickToWishlistLink = (event) => {
        event.preventDefault();
        const lmValue = errorMessages[errorType.current]?.landmark || errorMessages.FALLBACK.landmark;
        Landmark.sendClickLandmark(lmValue + '_toWishlist');
        window.location.href = event.currentTarget.href;
    };

    const {headline, content} = errorMessages[errorType.current] || errorMessages.FALLBACK;

    return (
        <Layer className="wishlist-error__layer" opened={opened} onClose={close}>
            <div className="layer__headline">{headline}</div>
            <div className="layer__text-content" dangerouslySetInnerHTML={{__html: content}}></div>
            <Button className="layer__button" onClick={close}>
                Ok
            </Button>
        </Layer>
    );
}
